<template>
  <v-container fluid>
    <v-row class="my-0 py-0" justify="center">
      <v-col sm="12" md="10">
        <v-sheet elevation="1">
          <v-row>
            <v-col sm="4" class="align-self-center">
              <div class="px-3">Work Order ID: <b>{{ workorder.forgeID }}</b></div>
            </v-col>
            <v-col sm="4" class="align-self-center">
              <div class="title d-flex justify-center">
                <v-icon left>{{ workorder.icon }}</v-icon>
                {{ workorder.name }}
              </div>
              <div class="d-flex justify-center">
                <StateChip :state="workorder.state" />
              </div>
            </v-col>
            <v-col sm="4" class="align-self-center">
              <div class="d-flex justify-end pa-1" v-if="true">
                <WorkOrderTransferToQue :workid="workid" :disabled="disabled" />
              </div>
            </v-col>
            <v-col sm="12" class="py-0 my-0">
              <v-divider />
            </v-col>
            <v-col sm="12" class="py-0 my-0">
              <v-tabs centered>
                <v-tab
                  :to="{ name: 'WorkOrderSummaryView', params: { workid: workid, id: id } }"
                >
                  Overview
                </v-tab>
                <v-tab
                  :to="{ name: 'WorkOrderBatchesListView', params: { workid: workid, id: id } }"
                >
                  Batches
                </v-tab>
                <v-tab
                  :to="{ name: 'WorkOrderQualityListView', params: { workid: workid, id: id } }"
                >
                  Quality
                </v-tab>
              </v-tabs>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>
    </v-row>
    <v-row class="my-0 py-0" justify="center">
      <router-view :workid="workid" :id="id" />
    </v-row>
  </v-container>
</template>

<script>
import WorkOrder from "../../models/WorkOrder";
import WorkOrderTransferToQue from "../../components/WorkOrders/WorkOrderTransferToQue";
import StateChip from "../../components/State/StateChip";
export default {
  name: "WorkOrderDetailView",
  components: {StateChip, WorkOrderTransferToQue },
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    workid: {
      type: [Number, String],
      required: true
    }
  },
  computed: {
    workorder() {
      return WorkOrder.query()
        .with("state")
        .find(parseInt(this.workid))
    },
    disabled() {
      return !(this.workorder.state.name === 'Completed' || this.workorder.state.name === 'Incomplete');
    }
  }
}
</script>
